import { Resolve } from '@angular/router';
import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { APIService } from '../service/api.service';
import { map, catchError } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ApresentacaoResolver implements Resolve<[]> {
  resultados: [];
  constructor(private api: APIService) { }
  resolve(): Observable<any> | Promise<any> {
    return this.api.getCatalogoInfo().pipe(
      map((catalogoInfo) => catalogoInfo),
      catchError((error) => of({ catalogoInfoError: error })),
    );
  }
}
